import type { Gateway } from '@enmon/commons/lib/meters';
import type { SortOrder } from 'antd/lib/table/interface';
import { mapAntdSortOrder } from 'routes/toolbox/gateways/utils';
import { BaseApiClient } from '../baseApiClient';

export interface GatewaysFilter {
  type?: string;
}

export interface GatewaysPagination {
  page: number;
  pageSize: number;
}

export interface GatewaysSorting {
  field?: keyof Gateway;
  order?: SortOrder;
}

export interface GetGatewaysParams {
  filter?: GatewaysFilter;
  pagination?: GatewaysPagination;
  sorting?: GatewaysSorting;
}

export interface GetGatewaysResponse {
  result: Gateway[];
  totalCount: number;
}
export class GatewaysApiClient extends BaseApiClient {
  constructor(jwt: string) {
    super('enmon-tools/gateways', undefined, jwt);
  }

  async findAll(params: GetGatewaysParams & { signal?: AbortSignal }): Promise<GetGatewaysResponse> {
    const { filter, pagination, sorting, signal } = params;

    const queryParams: Record<string, any> = {};

    if (pagination) {
      queryParams.limit = pagination.pageSize;
      queryParams.skip = (pagination.page - 1) * pagination.pageSize;
    }

    if (sorting?.field && sorting?.order) {
      queryParams.sort = `${sorting.field}:${mapAntdSortOrder(sorting.order)}`;
    }

    if (filter) {
      queryParams.filter = filter;
    }

    const response = await this.axios.get<GetGatewaysResponse>('', {
      params: queryParams,
      signal,
    });

    return response.data;
  }
}
